<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.bill') }}
			</div>
			<v-row>
				<v-col cols="12">
					<InputField
						v-model="paymentContractBill.bill_number"
						:errorBorder="!paymentContractBillValidation.bill_number"
						:label="'* ' + $t('fields.billNumber')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<DatePicker
						v-model="paymentContractBill.date"
						:errorBorder="!paymentContractBillValidation.date"
						:date-label="'* ' + $t('fields.date')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<NumberField
						v-model="paymentContractBill.total"
						:precision="2"
						:errorBorder="!paymentContractBillValidation.total"
						:label="'* ' + $t('fields.amountBruto')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<Upload
						:readonly="false"
						:showDelete="false"
						v-model="paymentContractBill.uploaded_file"
						:label="$t('fields.file')"
					></Upload>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn
					v-if="billId != 0 && $myStore.state.user.user_role_id == 1"
					class="ma-2"
					color="warning"
					variant="text"
					@click="deleteClick(paymentContractBill.id)"
				>
					{{ $t('buttons.delete') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import InputField from '../../trinkets/InputField';
import Upload from '../../trinkets/Upload';
import DatePicker from '../../trinkets/DatePicker';
import NumberField from '../../trinkets/NumberField';
import PaymentContractBill from '../../../models/PaymentContractBill';

export default {
	name: 'PaymentContractBill',
	components: { NumberField, InputField, DatePicker, Upload },
	props: {
		billId: [String, Number],
		createInvoiceAfterSaving: {
			type: Boolean,
			default: false,
		},
		redirectionRoute: String,
	},
	emits: ['close', 'reloadPaymentContractBills', 'reloadPaymentContract'],
	data() {
		return {
			paymentContractBill: new PaymentContractBill({
				id: this.billId,
				payment_contract_id: this.$route.params.id,
			}),
			paymentContractBillValidation: new PaymentContractBill({}, true),
		};
	},
	watch: {
		billId(newVal) {
			if (newVal) {
				this.getPaymentContractBill();
			}
		},
	},

	methods: {
		cancelClick() {
			this.paymentContractBill = new PaymentContractBill({
				id: null,
				payment_contract_id: this.$route.params.id,
			});
			this.$emit('close');
		},
		getPaymentContractBill() {
			var vm = this;
			this.$APICall(
				'get',
				'payment-contract-bill/' + this.billId,
				{},
				(data, success) => {
					if (success) {
						vm.paymentContractBill = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		deleteClick(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					vm.$APICall('delete', 'payment-contract-bills/' + id + '/delete', { id: id }, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicDelete'));
							vm.$modalBus.$emit('reloadPaymentContractBills');
							vm.$modalBus.$emit('reloadPaymentContract');
							vm.paymentContractBill = new PaymentContractBill({
								id: null,
								payment_contract_id: this.$route.params.id,
							});
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
						this.$emit('close');
					});
				}
			});
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.paymentContractBill.bill_number == null || this.paymentContractBill.bill_number == '') {
				success = false;
				this.paymentContractBillValidation.bill_number = false;
			} else {
				if (this.paymentContractBill.length > 255) {
					this.paymentContractBillValidation.bill_number = false;
					success = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.billNumber'))
							.replace('%max%', 255) + '<br />';
				}
				this.paymentContractBillValidation.bill_number = true;
			}

			if (this.paymentContractBill.date == null) {
				success = false;
				this.paymentContractBillValidation.date = false;
			} else {
				this.paymentContractBillValidation.date = true;
			}

			if (this.paymentContractBill.total == null || this.paymentContractBill.total == '') {
				success = false;
				this.paymentContractBillValidation.total = false;
			} else {
				this.paymentContractBillValidation.total = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.paymentContractBill.id) {
					action = 'put';
					addition = '/' + vm.paymentContractBill.id;
				}
				this.$APICall(
					action,
					'payment-contract-bills' + addition,
					this.paymentContractBill,
					(data, success) => {
						if (success) {
							if (vm.paymentContractBill.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.paymentContractBill = new PaymentContractBill({
								id: null,
								payment_contract_id: this.$route.params.id,
							});
							vm.$modalBus.$emit('reloadPaymentContractBills');
							vm.$modalBus.$emit('reloadPaymentContract');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
						this.$emit('close');

						if (vm.createInvoiceAfterSaving) vm.$router.replace(vm.redirectionRoute);
					}
				);
			}
		},
	},
	mounted() {
		if (this.billId) {
			this.getPaymentContractBill();
		}
	},
};
</script>
